import ApiService from '@/services/api.service'

const FirstDataBankService = {

    getDrugs(Criteria, limit, DrugType) {
        const params = {
            SearchText: Criteria
        };
        if (limit != null) {
            params.Limit = limit;
        }

        params.SearchType = "Contains";

        return ApiService.customRequest({
            method: 'get',
            url: `/FirstDatabank/${DrugType}`,
            params
        });
    },

    getPackagedDrugs(DrugType,Id,limit) {
        const params = {};
        if (limit != null) {
            params.Limit = limit;
        }
        return ApiService.customRequest({
            method: 'get',
            url: `/FirstDatabank/${DrugType}/${Id}/EquivalentPackagedDrugs`,
            params
        });
    },

    getDrugsById(DrugType,Id) {
    return ApiService.get(`/FirstDatabank/${DrugType}/${Id}`);
    },

    getIndicationsById(DrugType,Id) {
    return ApiService.get(`/FirstDatabank/${DrugType}/${Id}/IndicationLinks`);
    },

    getSideEffectLinksById(DrugType,Id) {
    return ApiService.get(`/FirstDatabank/${DrugType}/${Id}/SideEffectLinks`);
    },

    getInteractionsById(DrugType,Id) {
    return ApiService.get(`/FirstDatabank/${DrugType}/${Id}/Interactions`);
    },

    getProfessionalMonographsById(Id) {
    return ApiService.get(`/FirstDatabank/DrugDrugProfessionalMonographs/${Id}`);
    },

    getPatientEducationMonographsById(DrugType,Id) {
    return ApiService.get(`/FirstDatabank/${DrugType}/${Id}/PatientEducationMonographs`);
    },

    getDosageRecordsById(DrugType, Id, DosageModule) {
        const url =
            `/FirstDatabank/${DrugType}/${Id}/DoseRecords` +
            (DosageModule != null ? `?doseModule=${DosageModule}` : '');

        return ApiService.get(url);
    },

    getLabelWarningDrugLinksById(DrugType,Id) {
    return ApiService.get(`/FirstDatabank/${DrugType}/${Id}/LabelWarningDrugLinks`);
    },

    getInteroperabilityById(DrugType,Id) {
    return ApiService.get(`/FirstDatabank/${DrugType}/${Id}/Interoperability`);
    },

    getClinicalQuantitiesById(DrugType,Id) {
    return ApiService.get(`/FirstDatabank/${DrugType}/${Id}/ClinicalQuantities`);
    },

    getPackagedDrugsImage(Id) {
    return ApiService.get(`/FirstDatabank/PackagedDrugs/${Id}/Images`);
    },

    getPackageDrugCurrentPrice(Id) {
    return ApiService.get(`/FirstDatabank/PackagedDrugs/${Id}/CurrentPrices`);
    },

}

export default FirstDataBankService;
